import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

interface ContentTranslations {
  title: string
  description: string
}

const dental_generic_failure = (
  params: StepConfigParams,
  config: {
    translations: ContentTranslations
  }
) => {
  return {
    stepContent: [
      {
        type: 'spacer',
        size: 'xlarge',
      },
      {
        type: 'spacer',
        size: 'xsmall',
      },
      {
        type: 'image',
        src: 'https://cdn.sanity.io/images/p4gom3ch/production/0de353a55462635c64b09ddc7843b932193fe47b-624x698.png',
        width: 205,
        height: 205,
        align: 'center',
        useURI: true,
        contentFit: 'contain',
      },
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: config.translations.title,
        },
        align: 'center',
        size: 'h3',
      },
      {
        type: 'text',
        emphasis: 'default',
        text: {
          type: 'translatableText',
          translationKey: config.translations.description,
        },
        style: 'body1',
        align: 'center',
      },
    ],
    subFlow: params.subFlow,
    hideProgressBar: true,
    footer: {
      customButtons: [
        {
          buttonId: 'dental_failure_closed',
          buttonType: 'default',
          buttonLabel: {
            type: 'translatableText',
            translationKey: 'sharedFlows_dental:steps.dental_generic_failure.done',
          },
          actionConfig: {
            type: 'dispatchedHook',
            callbackConfig: {
              name: 'endDentalFlow',
              inputs: [],
              outputs: [],
            },
          },
        },
      ],
    },
    isFailureStep: true,
  } as const satisfies AnyStepConfiguration
}

export default dental_generic_failure
